// LocationForm.tsx
import React, { useState } from "react";
import { Box, TextField, Button, CircularProgress } from "@mui/material";
import { WarehouseLocation } from "../../../interfaces/document";

interface LocationFormProps {
  initialData?: WarehouseLocation | null;
  onSubmit: (name: string) => Promise<void>;
  isLoading?: boolean;
}

const LocationForm = ({
  initialData,
  onSubmit,
  isLoading,
}: LocationFormProps) => {
  const [name, setName] = useState(initialData?.name || "");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(name);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
      <TextField
        fullWidth
        label="Nome Ubicazione"
        value={name}
        onChange={(e) => setName(e.target.value)}
        disabled={isLoading}
        sx={{ mb: 3 }}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          type="submit"
          variant="contained"
          disabled={!name || isLoading}
          sx={{ minWidth: 120 }}
        >
          {isLoading ? (
            <CircularProgress size={24} />
          ) : initialData ? (
            "Salva"
          ) : (
            "Crea"
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default LocationForm;
